import type { BuilderCampaignPayload } from "@/interfaces/campaignDraft";
import type { CollectionWithProducts } from "@/types/types";

/**
 * Freeze Gift Selection (GFG-409) decisions for Step 1, kept out of the builder context so they can
 * be tested on their own.
 */

/**
 * The frozen feed Step 1 draws its grid from: the loaded one while the toggle is on and the loaded
 * tier is shown. Null otherwise, so the grid is the live tier.
 */
export function step1FrozenCollections(
  freezeGiftSelection: boolean,
  selectedBudget: number | null,
  hydratedBudget: number | null,
  frozenCollections: CollectionWithProducts[] | null,
): CollectionWithProducts[] | null {
  return freezeGiftSelection && selectedBudget === hydratedBudget ? frozenCollections : null;
}

/** The collections Step 1's grid is drawn from: the frozen feed when there is one, else the live tier. */
export function step1GridCollections(
  frozenCollections: CollectionWithProducts[] | null,
  liveCollections: CollectionWithProducts[] | undefined,
): CollectionWithProducts[] | undefined {
  return frozenCollections ?? liveCollections;
}

/** Whether a saved payload changes the server's Freeze Gift Selection, so Step 1 must be re-read. */
export function freezeChangedBy(payload: BuilderCampaignPayload, serverFreeze: boolean): boolean {
  return payload.freezeGiftSelection !== undefined && payload.freezeGiftSelection !== serverFreeze;
}
